/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

(function ($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function () {

				$(".js-cart-delete-btn").on("click", function(){

					var data = {
						"id":			$(this).data("id"),
						"post_type":	$(this).data("post-type"),
						"extra_params": $(this).data("extra-params")
					}

					var parentRow = $(this).parents(".btn-col").parent();

					var postType = $(this).data("post-type");

					toggleCartLoadingIcon(parentRow);

					if(postType === "c5_event"){
						toggleCartLoadingIcon(parentRow.siblings(".line-item-row"));
					}

					ticketDeleted = false;

					$.post(
						ajaxVars.store_ajaxurl,
						{
							"action": "delete_from_cart",
							"data": $.param(data)
						},
						function(data) {

							if(data.status){

								if(data.do_refresh){
									window.location.reload(true);
								}

								var parentTable = parentRow.parents("table");

								if(parentRow.is("tr[class=line-item-row]") && parentRow.next().hasClass("sub-item-header-row")){
									parentRow.nextUntil("tr:not(.sub-item-row)").remove();
								}

								parentRow.remove();

								parentTable.trigger("rm.cart.updated");

								ticketDeleted = true;

							}else{

								toggleCartLoadingIcon(parentRow);

								if(postType === "c5_event"){
									toggleCartLoadingIcon(parentRow.siblings(".line-item-row"));
								}

							}

						}

					);

					if(postType === "c5_event" && ticketDeleted){

						$(parentRow.siblings(".line-item-row").find(".js-cart-delete-btn")).each(function() {

							var addonData = {
								"id":			$(this).data("id"),
								"post_type":	$(this).data("post-type"),
								"extra_params": $(this).data("extra-params")
							}

							var addonParentRow = $(this).parents(".btn-col").parent();

							$.post(
								ajaxVars.store_ajaxurl,
								{
									"action": "delete_from_cart",
									"data": $.param(addonData)
								},
								function(data) {

									if (data.status) {

										if (data.do_refresh) {
											window.location.reload(true);
										}

										var parentTable = addonParentRow.parents("table");

										addonParentRow.remove();

										parentTable.trigger("rm.cart.updated");

									} else {

										toggleCartLoadingIcon(addonParentRow);

									}

								}
							);

						});

					}

				});

				$(".js-cart-update-quantity").on("change", function(){

					var quantitySelect = $(this);

					var data = {
						"id":			$(this).data("id"),
						"post_type":	$(this).data("post-type"),
						"quantity":		$(this).val()
					};

					var parentRow = quantitySelect.parents(".quantity-col").parent();

					var postType = $(this).data("post-type");

					$(this).prop("disabled", true);
					toggleCartLoadingIcon(parentRow);

					if(postType === "c5_event"){
						parentRow.siblings(".line-item-row").find(".js-cart-update-quantity").prop("disabled", true);
						toggleCartLoadingIcon(parentRow.siblings(".line-item-row"));
					}

					qtyUpdated = false;

					if(typeof $(this).data("extra-params") !== undefined && $(this).data("extra-params") !== ""){
						data.extra_params = $(this).data("extra-params");
					}

					$.post(
						ajaxVars.store_ajaxurl,
						{
							"action": "update_cart",
							"data": $.param(data)
						},
						function(data) {

							if(data.status){

								updateDiscountAmount(parentRow, data.discount_amount);

								var updatedItemIds = [data.updated_item_id];

								if(!parentRow.is(".sub-item-row")) {

									parentRow.siblings(".sub-item-row:not(.sub-item-header-row)").each(function () {

										if(parseInt($(".js-cart-update-quantity", this).val()) > parseInt(quantitySelect.val())){

											$(".js-cart-update-quantity", this).val(quantitySelect.val());

											updatedItemIds.push($(this).data("item-id"));

										}

										if(parseInt($(".js-cart-update-quantity option:last-child", this).val()) < parseInt(quantitySelect.val())){

											// Add
											var i = parseInt($(".js-cart-update-quantity option:last-child", this).val()) + 1;
											var maxQuantity = parseInt(quantitySelect.val());

											for(i; i <= maxQuantity; i++){

												$(".js-cart-update-quantity", this).append(
													$("<option>")
														.attr("value", i)
														.text(i)
												);

											}

										}else if(parseInt($(".js-cart-update-quantity option:last-child", this).val()) > parseInt(quantitySelect.val())){

											// Remove
											$(".js-cart-update-quantity option", this).slice(parseInt(quantitySelect.val()) + 1).remove();

										}

									});

								}

								parentRow.trigger("rm.cart.updated", [updatedItemIds]);

								qtyUpdated = true;

							}else{



							}

						}

					);

					if(postType === "c5_event" && qtyUpdated) {

						var conferenceQty = parseInt($(this).parents('tbody').find('tr:first-child select').val()) + parseInt($(this).parents('tbody').find('tr:nth-child(2) select').val());

						$(parentRow.siblings(".line-item-row").find(".js-cart-update-quantity")).each(function() {

							var addonQty = parseInt($(this).val());

							var addonParentRow = $(this).parents(".quantity-col").parent();

							$(this).children(":not(:first-child)").remove();

							for (i = 2; i <= conferenceQty; i++) {

								$(this).append("<option value=\"" + i + "\">" + i + "</option>");

							}

							if (addonQty > conferenceQty) {

								addonQty = conferenceQty;

								var addonData = {
									"id":			$(this).data("id"),
									"post_type":	$(this).data("post-type"),
									"quantity":		addonQty.toString()
								};

								if (typeof $(this).data("extra-params") !== undefined && $(this).data("extra-params") !== "") {
									addonData.extra_params = $(this).data("extra-params");
								}

							}

							$(this).val(addonQty);

							if (typeof addonData !== undefined) {

								$.post(
									ajaxVars.store_ajaxurl,
									{
										"action": "update_cart",
										"data": $.param(addonData)
									},
									function(data) {

										if (data.status) {

											updateDiscountAmount(addonParentRow, data.discount_amount);

											addonParentRow.trigger("rm.cart.updated", [data.updated_item_id]);

										} else {



										}

									}
								);

							}

						});

					}

					quantitySelect.prop("disabled", false);
					toggleCartLoadingIcon(parentRow);

					if(postType === "c5_event"){
						parentRow.siblings(".line-item-row").find(".js-cart-update-quantity").prop("disabled", false);
						toggleCartLoadingIcon(parentRow.siblings(".line-item-row"));
					}

				});

				$(".pk-code-form").on("submit", function(){

					var pkCodeForm = $(this);

					setPKCodeFormDisabled($(this), true);

					var submitBtn = pkCodeForm.find(".input-group .input-group-btn");

					var submitBtnText = submitBtn.find(".btn").text();

					submitBtn
						.css("width", submitBtn.width())
						.find(".btn")
							.css("width", "100%")
							.html(
								$("<span>").addClass("fa fa-pulse fa-spinner")
							);

					pkCodeForm.find("span.help-block").remove();

					$.post(
						ajaxVars.store_ajaxurl,
						{
							"action": "apply_pk_code",
							"data": $(this).serialize()
						},
						function(data) {

							if(data.status){

								if(Number(data.discount_amount) > 0){

									var parentRow = pkCodeForm.parents(".key-code-col").parent();

									updateDiscountAmount(parentRow, data.discount_amount);

									parentRow.trigger("rm.cart.updated", [data.updated_item_id]);

								}

							}else{

								pkCodeForm.addClass("has-error");

								pkCodeForm.append(
									$("<span>").addClass("help-block text-danger").text(data.message)
								);

							}

							setPKCodeFormDisabled(pkCodeForm, false);

							submitBtn
								.css("width", "auto")
								.find(".btn")
									.text(submitBtnText);

						}

					);

					return false;

				});

				$("#cart").on("rm.cart.updated", function(evt, updated_item_ids){

					var cartSubtotal = 0;
					var cartDiscountTotal = 0;

					var cartCurrencySymbol = $(".js-cart-currency-symbol", this).val();

					if(typeof updated_item_ids !== "object"){
						updated_item_ids = [updated_item_ids];
					}

					if($("tr.line-item-row", this).length < 1){

						var emptyCartElement =
							$("<tr>")
								.addClass("line-item-row")
								.append(
									$("<td>")
										.addClass("item-col")
										.prop("colspan", 4)
										.append(
											$("h5").text("Your cart is currently empty")
										)
								)
								.append(
									$("<td>").addClass("btn-col")
								);

						if($("tbody tr:first-child", this).hasClass("ecom-order-table-header-row")){

							$(".ecom-order-table-header-row", this).after(emptyCartElement);

						}else{

							$("tbody", this).prepend(emptyCartElement);

						}

						$("#js-checkout-terms-modal").remove();

						$(".cart-checkout-btn button").prop("disabled", true);

					}else{

						$("tr.line-item-row", this).each(function(){

							var quantity = ($(".js-cart-update-quantity", this).length > 0) ? parseInt($(".js-cart-update-quantity", this).val()) : 1;

							// More accurate way of rounding a float
							// Math.pow(10, 2): 2 == the number of decimal places to round to
							var unitPrice = Math.round(parseFloat($(".js-line-item-unit-price", this).val()) * Math.pow(10, 2)) / Math.pow(10, 2);
							var lineItemSubTotal = unitPrice * quantity;

							var unitDiscount = 0.0;

							if($(".js-line-item-discount-amount", this).length > 0){
								unitDiscount = Math.round(parseFloat($(".js-line-item-discount-amount", this).val()) * Math.pow(10, 2)) / Math.pow(10, 2);
							}

							var lineItemTotalDiscount = unitDiscount * quantity;

							cartSubtotal += lineItemSubTotal;
							cartDiscountTotal += lineItemTotalDiscount;

							if(updated_item_ids.indexOf($(this).data("item-id")) >= 0){

								var hasSlashedPrice = ($(".price-col", this).has("h4.slashed-price").length > 0) ? true : false;

								var lineItemTotal = lineItemSubTotal - lineItemTotalDiscount;

								var subTotalElement;

								// Select element that contains the subtotal text
								if(hasSlashedPrice){

									subTotalElement = $(".price-col .slashed-price", this);

								}else{

									subTotalElement = $(".price-col .js-line-item-total", this);

								}

								// Update line item subtotal
								// Regular expression replaces any digit that is followed by one or more
								// groups of three digits and a decimal point with that digit plus a comma.
								// Essentially formats the number by grouped thousands
								subTotalElement.text(cartCurrencySymbol + lineItemSubTotal.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,"));

								if(lineItemTotalDiscount > 0){

									// If the slashed prices isn't being displayed, display it
									if(!hasSlashedPrice) {

										// Convert the current sub total price to the slashed price
										$(".price-col .js-line-item-total", this)
											.removeClass("js-line-item-total")
											.addClass("slashed-price");

										// Add a new line item total element
										$(".price-col .slashed-price", this)
											.after(
												$("<h4>").addClass("js-line-item-total")
											);

									}

									// Update the line item total
									$(".price-col .js-line-item-total", this).text(cartCurrencySymbol + lineItemTotal.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,"));

								}else if(hasSlashedPrice){

									$(".price-col .js-line-item-total", this).remove();

									$(".price-col .slashed-price", this)
										.removeClass("slashed-price")
										.addClass("js-line-item-total");

								}

							}

						});

						// If a tr with the table header class is the first child of a body, we know that all
						// the conference cart items have been removed, so we'll remove the conference items header
						if($("tbody tr:first-child", this).hasClass("ecom-order-table-header-row")){

							$("thead > tr", this).hide();

						}

						// If the row after the second table header row is not a line item, then
						// all the items under that have been removed, so we'll that header
						$(".ecom-order-table-header-row", this).each(function(){

							if(!$(this).next().hasClass("line-item-row")){
								$(this).hide();
							}

						});

						$(".sub-item-header-row", this).each(function(){

							if(!$(this).next().hasClass("sub-item-row")){
								$(this).hide();
							}

						});

					}

					var cartTotal = cartSubtotal - cartDiscountTotal;

					$("#order-subtotal-display").text(cartCurrencySymbol + cartSubtotal.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,"));
					$("#order-discount-total-display").text(cartCurrencySymbol + cartDiscountTotal.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,"));

					$("#order-total-display").text(cartCurrencySymbol + cartTotal.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,"));

				});

				$(".js-tooltip-toggle").tooltip({
					container:	"body",
					html:		true
				});

				$("#cart-how-did-you-hear-select").on("change", function(){

					$("#checkout-start-form").find('input[name="data[how_did_you_hear]"]').val($(this).val());

				});

				$(".checkout_terms_of_service_checkbox input").on("change", function(){

					if ($(this).prop("checked")) {

						$('#checkout-start-form button[type="submit"]').prop('disabled', false);

					} else {

						$('#checkout-start-form button[type="submit"]').prop('disabled', true);

					}

				});

				$('.account-signin-toggle .radio input[data-toggle="tab"]').on("shown.bs.tab", function(evt){

					// For the show.bs.tab event, the currently active panel is the one that's about to be hidden
					$($(this).data("target")).parent().find(".tab-pane:not(.active)")
						.find(".form-group :input").prop("disabled", true);

					// For the show.bs.tab event, the clicked tag's target is the panel that's about to be shown
					$($(this).data("target")).find(".form-group :input").prop("disabled", false);


				});

				$(".account-signin-fields .checkout-details-fieldset.tab-pane:not(.active.in)")
					.find(".form-group :input").prop("disabled", true);

				$(".event-attendee-info-fields")
					.on("blur", ".attendee-details-fieldset .form-group input.form-control", manageAutofillProfiles)
					.on("change", ".attendee-details-fieldset .form-group select.form-control:enabled, .attendee-details-fieldset .radio-group input .attendee-details-fieldset, .checkbox.form-group-column input", manageAutofillProfiles);

				if(typeof autofillProfiles === "undefined"){
					autofillProfiles = {};
				}

				if($("form.checkout-form-assign-workshops").length > 0 && $(".event-attendee-info-fields .js-select-autofill-profile").length > 0){

					var localStoredAutofillProfiles = localStorage.getItem("c5_autofill_profiles");

					if(localStoredAutofillProfiles !== null){

						autofillProfiles = JSON.parse(localStoredAutofillProfiles);

					}

					if(Object.keys(autofillProfiles).length > 0){

						for(var autofillProfileIdentity in autofillProfiles){

							var autofillProfile = autofillProfiles[autofillProfileIdentity];

							$(".event-attendee-info-fields .js-select-autofill-profile").append(
								$("<option>")
									.attr("value", autofillProfileIdentity)
									.text(autofillProfile.first_name + " " + autofillProfile.last_name)
							);

						}

						$(".event-attendee-info-fields .attendee-profile-select-wrap").show();

					}

				}

				$(".js-select-autofill-profile").on("change", function(){

					if($(this).val() !== "" && (typeof autofillProfiles !== "undefined")){

						var profileHash = $(this).val();

						if(typeof autofillProfiles[profileHash] !== "undefined"){

							var profile = autofillProfiles[profileHash];

							var form = $($(this).data("target"));

							autofillForm(form, profile);

						}

					}

				});

				$(".event-attendee-info-fields .js-select-autofill-profile").on("change", function(){

					var radioValue = ($(this).val() === "") ? "new" : "profile";

					$(this).parents(".attendee-profile-select-content-box")
						.find(':radio[name^="profile_select_toggle"]')
							.val([radioValue]);

				});

				$(".attendee-details-fieldset.attendee-additional").each(function(){

					var self = $(this);

					self.find(".input-registration-code").hide();

					if(self.find('.input-member-status input[value="MS"]').is(":checked")){

						self.find(".input-registration-code").show();

					}

					self.find('.input-member-status input').on("change", function(){

						self.find(".input-registration-code input").val("");

						if(self.find('.input-member-status input[value="MS"]').is(":checked")){

							self.find(".input-registration-code").show();

						} else {

							self.find(".input-registration-code").hide();
							
						}

					});

					self.find(".input-champion-status, .input-champion-luncheon").hide();

					self.find(".input-champion-status > label:first-child").text(function(i,t){

						return t + "*";

					});

					if(self.find('.input-member-status input[value="A"]').is(":checked")){

						self.find(".input-champion-status input").prop("required", true);
						self.find(".input-champion-status").show();

					}

					if(self.find('.input-champion-status input[value="Y"]').is(":checked")){

						self.find(".input-champion-luncheon").show();

					}

					self.find('.input-member-status input').on("change", function(){

						self.find(".input-champion-status input").prop("checked", false);
						self.find(".input-champion-luncheon input").prop("checked", false);

						if(self.find('.input-member-status input[value="A"]').is(":checked")){

							self.find(".input-champion-status input").prop("required", true);
							self.find(".input-champion-status").show();

						} else {

							self.find(".input-champion-status input").prop("required", false);
							self.find(".input-champion-status, .input-champion-luncheon").hide();
							
						}

					});

					self.find('.input-champion-status input').on("change", function(){

						self.find(".input-champion-luncheon input").prop("checked", false);

						if(self.find('.input-champion-status input[value="Y"]').is(":checked")){

							self.find(".input-champion-luncheon").show();

						} else {

							self.find(".input-champion-luncheon").hide();

						}

					});

					if(self.find(".input-first-time-attending input").is(":checked")){

						self.find(".input-be-a-mentor input").prop("checked", false);
						self.find(".input-be-a-mentor").hide();

					}
	
					self.find(".input-first-time-attending input").on("change", function(){

						self.find(".input-be-a-mentor input").prop("checked", false);
						self.find(".input-be-a-mentor").toggle();

					});

					self.find(".input-special-needs-description").hide();

					if(self.find(".input-special-needs input").is(":checked")){

						self.find(".input-special-needs-description").show();

					}

					self.find(".input-special-needs input").on("change", function(){

						self.find(".input-special-needs-description textarea").val("");
						self.find(".input-special-needs-description").toggle();

					});

				});

				$(".event-attendee-info-fields").each(function(){

					var self = $(this);

					if(self.find(".event-info-content-box .ticket-meta").length > 0){
						if(self.find(".event-info-content-box .ticket-meta").html().includes("Nonmember Retired/Student")){

							self.find(".input-nmv-eligibility > label:last-child").remove();

							self.find(".nonmember-validation-fields-wrap").show();

							self.find(".input-nmv-eligibility > label:first-child").html(function(i, s) { return s + "*"; });
							self.find(".input-nmv-eligibility input").attr("required", "required");

						}else{

							self.find(".input-nmv-eligibility > label:last-child input").prop("checked", true);

						}
					}

				});

				$("select[multiple]").select2();

				$(".input-dietary-restrictions select").select2('destroy').select2({
					placeholder: "Select all that apply"
				});

				$(".input-dietary-restrictions select").attr("required", "required");
				$(".input-dietary-restrictions label").html(function(i,h){
					return h + '*';
				});

				$(".input-dietary-restrictions select").on('select2:select', function (e) {
					// Check if the 'None' option is selected
					if (e.params.data.id === 'None') {
						// Deselect all other options
						$(this).val(['None']).trigger('change');
					} else {
						// Automatically deselect the 'None' option if any other option is selected
						var values = $(this).val();
						if (values) {
							var noneIndex = values.indexOf('None');
							if (noneIndex !== -1) {
								values.splice(noneIndex, 1);
								$(this).val(values).trigger('change');
							}
						}
					}
				});

				if($(".payment-form-embed-wrap").length > 0){

					if($(".payment-form-embed-wrap").is(":visible")){

						$(".checkout-next-prev-btns-row").toggleClass("payment-iframe-offset");

					}

				}

				$(':radio[name$="\\[billing_method\\]"]').on("click", function(){

					$(".payment-form-error-wrap, .payment-form-embed-wrap").toggle();

					$(".checkout-next-prev-btns-row").toggleClass("payment-iframe-offset");

				});

			}
		},
		// Cart page
		'page_cart': {
			init: function () {
				// JavaScript to be fired on the cart page



			}
		},
		// Payment Portal page
		'payment_portal': {
			init: function () {

				if(paymentPortalType === "cgen"){
					$('.content-payment-portal .page-header .page-title').text('Payment Guarantee');
				}

				if(typeof window.paymentPortalFinishedData !== 'undefined'){
					paymentPortalFinished(JSON.parse(window.paymentPortalFinishedData));
				}

				$('.page-template-page-payment-portal').css('opacity', '1');

				window.c5PaymentPortalData = {};

				c5PaymentPortalData.cs_email = csEmail();

				$('html').css('scroll-behavior', 'smooth');

				// Payment lookup form submit
				$('#payment-lookup-form').submit(function(){

					$('.payment-lookup-wrap, .payment-info-wrap').addClass('loading');
					$('.payment-lookup-data-fields')
					.prepend(
						$('<div>').addClass('loading-spinner-wrap')
						.append(
							$('<span>').addClass('spinner')
						)
					);
					$('.payment-info-form')
					.prepend(
						$('<span>').addClass('loading-spinner')
					);

					$.post(
						ajaxVars.store_ajaxurl,
						{
							'action': 'payment_portal_lookup',
							'data': $(this).serialize() + '&payment_portal_type=' + encodeURIComponent(paymentPortalType)
						},
						function(data) {

							if(data.status){

								//TODO Set all the things on successful lookup (fields and search readonly/disabled, amount due)
								c5PaymentPortalData.currency = data.order_data['currency'];
								c5PaymentPortalData.code = data.order_data['code'];
								c5PaymentPortalData.order_type = data.order_data['order_type'];
								c5PaymentPortalData.gateway_order_id = data.order_data['gateway_order_id'];
								c5PaymentPortalData.email = data.order_data['email'];

								$('input#amount-due').val(currencyCodeToSymbol(c5PaymentPortalData.currency) + data.order_data['amount']);

								$('.payment-lookup-wrap, .payment-info-wrap').addClass('order-loaded');
								$('input#order-number, input#lname').attr('readonly', true);

								if(c5SiteCodeName !== 'UK'){

									var paymentScript = '';
									var paymentForm = $('<iframe>').attr('src', data.payment_form_data['url'] + '/?uID=' + data.payment_form_data['uID']);

								}else{

									var paymentFormRedirectUrl = './?' + $.param({
										'status': 'finished',
										'order_number': $('#order-number').val(),
										'gateway_order_id': c5PaymentPortalData.gateway_order_id,
										'lname': $('#lname').val(),
										'amount': $('#amount-due').val(),
										'currency': c5PaymentPortalData.currency,
										'code': c5PaymentPortalData.code,
										'order_type': c5PaymentPortalData.order_type,
										'email': c5PaymentPortalData.email
									});

									var paymentScript = $('<script>').attr({'async': true, 'src': data.payment_form_data['script_url']});
									var paymentForm = $('<form>').addClass('paymentWidgets').attr({'action': paymentFormRedirectUrl, 'data-brands': data.payment_form_data['brands']});

								}

								$('.payment-info-form').removeClass('placeholder')
								.append(
									$('<div>').addClass('payment-info-form-embed' + (c5SiteCodeName === 'UK' ? ' payment-info-form-embed-dhpp' : ''))
									.append(
										$('<div>').addClass('embed-responsive')
										.append(paymentScript, paymentForm)
									),
									$('<div>').addClass('payment-info-form-msg')
									.append(
										$('<p>').html('Please press Complete only once.<br>If you receive an error or your submission does not appear to have completed, please contact <a href="mailto:' + c5PaymentPortalData.cs_email + '">Customer Service</a>.')
									)
								);

							}else{

								//TODO Set all the things on failed lookup, check error code & set msg then add error (green alert for PAID) and style alerts, clear appropriate JS vars
								$('input#order-number, input#lname').val('');
								paymentPortalLookupError(data.err);

							}

							$('.payment-lookup-data-fields .loading-spinner-wrap, .payment-info-form .loading-spinner').remove();
							$('.payment-lookup-wrap, .payment-info-wrap').removeClass('loading');

						}
					);

					return false;

				});

				// Payment lookup form reset
				$('#payment-lookup-form').on('reset', function(){

					setTimeout(function(){

						//TODO Toggle loading status visuals + disable functionality (turn this into a seperate function and call here and above)

						//TODO Reset all the things
						c5PaymentPortalData.currency = '';
						c5PaymentPortalData.code = '';
						c5PaymentPortalData.order_type = '';
						c5PaymentPortalData.gateway_order_id = '';
						c5PaymentPortalData.email = '';

						$('.payment-lookup-wrap, .payment-info-wrap').removeClass('order-loaded');
						$('input#order-number, input#lname').attr('readonly', false);

						$('.payment-info-form').addClass('placeholder').children(':not(p)').remove();

						$('.payment-error-block').children().remove();

						//TODO Toggle off loading status visuals + enable functionality (turn this into a seperate function and call here and above)

					}, 1);

				});

			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function (func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function () {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);


	var setPKCodeFormDisabled = function(form, disabledVal){

		form.find(".btn").prop("disabled", disabledVal);
		form.find(".form-control").prop("readonly", disabledVal);

	};

	var updateDiscountAmount = function(lineItemRow, discountAmount){

		var unitDiscountAmount = parseFloat(discountAmount);

		lineItemRow.find(".js-line-item-discount-amount").val(unitDiscountAmount);

	};

	var toggleCartLoadingIcon = function(lineItemRow){

		lineItemRow.find(".btn-col .js-cart-delete-btn").toggle();
		lineItemRow.find(".btn-col .js-loading-icon").toggle();

	};

	var autofillForm = function(form, values, namePrefix){

		for(var fieldName in values){

			if(typeof values[fieldName] === "object"){

				autofillForm(form, values[fieldName], '\\[' + fieldName + '\\]');

			}else if(values[fieldName] !== ""){

				var fieldNameSelector = ':input[name$="';

				if((typeof namePrefix !== "undefined") && namePrefix !== ""){
					fieldNameSelector += namePrefix;
				}

				fieldNameSelector += '\\[' + fieldName + '\\]"]';

				var field = form.find(fieldNameSelector);

				if(field.length > 0){

					if(field.attr("type") === "radio" || field.attr("type") === "checkbox"){

						field.val([values[fieldName]]);

					}else{

						field.val(values[fieldName]);

					}

					field.change();

				}

			}

		}

	};

	var manageAutofillProfiles = function(evt){

		var profileCompleted = true;

		$(".attendee-details-fieldset", evt.delegateTarget).find(".form-group .form-control:enabled, .radio-group input").each(function(){

			if($(this).prop("required") && $(this).val() === ""){
				profileCompleted = false;
			}

		});

		if(!profileCompleted){
			return;
		}

		var autofillProfile = {};

		$(".attendee-details-fieldset", evt.delegateTarget).find(".form-group .form-control:enabled, .radio-group input, .checkbox.form-group-column input").each(function(){

			if($(this).attr("name") === "" || $(this).attr("name") === undefined){
				return;
			}

			if($(this).is(":radio, :checkbox") && !$(this).prop("checked")){
				return;
			}

			var fieldName = $(this).attr("name").replace(/^data\[(addon_)?attendees\]\[\d\]/, "");

			var nameMatchedParts = fieldName.match(/\[[^\[\]]*\]/g);

			if(nameMatchedParts.length > 1){

				var profileParentProperty = nameMatchedParts[0].substring(1, (nameMatchedParts[0].length - 1));

				if(!autofillProfile.hasOwnProperty(profileParentProperty)){
					autofillProfile[profileParentProperty] = {};
				}

				var profileProperty = nameMatchedParts[1].substring(1, (nameMatchedParts[1].length - 1));

				autofillProfile[profileParentProperty][profileProperty] = $(this).val();

			}else{

				var profileProperty = nameMatchedParts[0].substring(1, (nameMatchedParts[0].length - 1));

				autofillProfile[profileProperty] = $(this).val();

			}

		});

		var identityUpdated = false;

		// If identity field has been updated, change value of existing option in select and delete old autofill profile
		if(evt.delegateTarget.hasAttribute("data-profile-identity") && $(evt.delegateTarget).data("profile-identity") !== autofillProfile.identity){

			identityUpdated = true;

			delete autofillProfiles[$(evt.delegateTarget).data("profile-identity")];

		}

		autofillProfiles[autofillProfile.identity] = autofillProfile;

		try {

			localStorage.setItem("c5_autofill_profiles", JSON.stringify(autofillProfiles));

		} catch(error){



		}

		$(".js-select-autofill-profile").each(function(){

			if(identityUpdated){
				$('option[value="' + $(evt.delegateTarget).data("profile-identity") + '"]', this).remove();
			}

			if($(this).children('option[value="' + autofillProfile.identity + '"]').length === 0){

				$(this).append(
					$("<option>")
						.attr("value", autofillProfile.identity)
						.text(autofillProfile.first_name + " " + autofillProfile.last_name)
				);

			}

		});

		$(evt.delegateTarget).attr("data-profile-identity", autofillProfile.identity);

	};

	var csEmail = function(){

		var user = 'customerservice@';

		switch (c5SiteCodeName) {

			case 'ACI':
				return user + 'americanconference.com';

			case 'CI':
				return user + 'canadianinstitute.com';

			case 'UK':
				return 'enquiries@c5-online.com';

			case 'ALA':
				return user + 'alaannualconf.org';

			case 'AALL':
				return user + 'aallconference.org';

		}

	};

	var currencyCodeToSymbol = function(currencyCode){

		switch (currencyCode) {

			case 'USD':
			case 'CAD':
				return '$';

			case 'GBP':
				return '£';

			case 'EUR':
				return '€';

		}

	};

	var paymentPortalLookupError = function(err){

		switch (err) {

			case 'LOOKUPDATA':
				var errMsg = {
					msg: 'Order Number or Name missing, please provide all information and try your search again.',
					type: 'danger'
				};
				break;

			case 'PAID':
				var errMsg = {
					msg: 'This order has already been paid, thank you!',
					type: 'success'
				};
				break;

			case 'NOORDER':
				var errMsg = {
					msg: 'No order information found, please contact <a href="mailto:' + c5PaymentPortalData.cs_email + '" class="alert-link">customer service</a>.',
					type: 'danger'
				};
				break;

			case 'PAYMENTFORM':
				var errMsg = {
					msg: 'We have encountered an error, please try again or contact <a href="mailto:' + c5PaymentPortalData.cs_email + '" class="alert-link">customer service</a>.',
					type: 'danger'
				};
				break;

		}

		var alertBox =
		$('<div>').addClass('alert alert-' + errMsg.type + ' alert-dismissible payment-lookup-error').attr('role', 'alert')
		.append(
			$('<button>').addClass('close').attr({type: 'button', 'aria-label': 'Close', 'data-dismiss': 'alert'})
			.append(
				$('<span>').attr('aria-hidden', 'true').html('&times;')
			)
		);

		$('#js-payment-lookup-error-block')
		.append(
			alertBox.append(
				$('<p>').html(errMsg.msg)
			)
		);

	};

	var paymentPortalFinished = function(data){

		//* Keep in sync with post ajax request in the content-payment-portal.php template file -> completeHostedPayment fn
		$.post(
			ajaxVars.store_ajaxurl,
			{
				'action': 'payment_portal_complete',
				'data': $.param(data)
			},
			function(data) {

				if(data.status){

					var successHeading = 'Payment Complete';
					var successMsg = 'Your payment has been successfully processed!';
					var newLookupLink = './';

					if(paymentPortalType === "cgen"){
						successHeading = 'Payment Guarantee Complete';
						successMsg = 'Your credit card guarantee has been submitted!';
						newLookupLink += '?type=cgen';
					}

					//TODO Switch all the things to success message (one box saying thank you with a button to lookup another payment that reloads the page)
					$('#payment-lookup-form, .content-payment-portal > div.row:last-child').remove();
					$('.payment-lookup-wrap').removeClass('payment-lookup-wrap').addClass('payment-complete-wrap');

					$('.payment-complete-wrap')
					.prepend(
						$('<div>').addClass('payment-complete')
						.prepend(
							$('<div>').addClass('payment-complete-heading')
							.prepend(
								$('<h2>').text(successHeading)
							),
							$('<div>').addClass('payment-complete-msg')
							.prepend(
								$('<p>').text(successMsg),
								$('<a>').attr('href', newLookupLink).addClass('reload-btn').text('New Lookup')
							)
						)
					);

				}else{

					//TODO Confirm below error handling is sufficient (need to mimic above behaviour, but instead of complete have error with the error msg and the new lookup/try again button)
					hostedHandleDetailErrors(300);

				}

			}
		);

	};

})(jQuery); // Fully reference jQuery after this point.
